const quizData = [
  {
    id: 1,
    mediaLink: "/assets/tweet-1934222037364482223.jpg",
    mediaType: "image",
    isAIGenerated: true,
    title: "'AI restored this family photo.' Is it true?",
    source: "Unknown Source: https://x.com/General_Oluchi/status/1934222037364482223",
    explanation: "As much as AI can be used to restore or enhance images, it cannot create realistic details from a single damaged photo without introducing artifacts. Also, pay close attention to the eyes and hands. The eyes have a subtle asymmetry and slightly unnatural glint, and one of the hands shows an extra finger and distorted proportions, which are very common AI tells. People promoting AI restoration often hype the technology, but the results can still be quite flawed.",
    pointers: ["Subtle eye asymmetry", "Distorted or extra fingers on hands", "Unnatural skin texture around the face", "Unusual lighting not typical of real photography"]
  },
  {
    id: 2,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+2", // Placeholder for a real photo
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a natural landscape real or AI-generated?",
    source: "National Geographic",
    explanation: "This is a real photograph. The textures of the rocks and water appear natural and consistent, and the lighting perfectly reflects the environment. AI often struggles to replicate the intricate, random details found in nature perfectly.",
    pointers: ["Natural rock textures", "Consistent water flow and reflections", "Realistic light and shadow play"]
  },
  {
    id: 3,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+3", // Placeholder for another AI-generated image
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this portrait of an elderly person real or AI-generated?",
    source: "Generated by DALL-E",
    explanation: "This portrait is AI-generated. Pay close attention to the eyes and hands. The eyes have a subtle asymmetry and slightly unnatural glint, and one of the hands shows an extra finger and distorted proportions, which are very common AI tells.",
    pointers: ["Subtle eye asymmetry", "Distorted or extra fingers on hands", "Unnatural skin texture around the face"]
  },
  {
    id: 4,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+4", // Placeholder for a real photo
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this image of a busy street market real or AI-generated?",
    source: "Getty Images",
    explanation: "This is a genuine photograph. The individual faces in the crowd are distinct and varied, and the small background details like vendor signs and product labels are legible and coherent. AI often struggles with rendering consistent details in large crowds or complex text.",
    pointers: ["Distinct and varied faces in crowd", "Legible background text/signs", "Natural interaction between elements"]
  },
  {
    id: 5,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+5", // Placeholder for a video (image used as placeholder)
    mediaType: "image", // Using image placeholder, but conceptually could be video
    isAIGenerated: true,
    title: "Is this 'screenshot' from a historical reenactment real or AI-generated?",
    source: "Generated by RunwayML (simulated)",
    explanation: "This is likely AI-generated. While appearing plausible at first glance, look closely at any written text or small objects. Text is often garbled or nonsensical, and small accessories or background elements may merge or show strange artifacts. Also, historical accuracy details can be subtly wrong.",
    pointers: ["Garbled or nonsensical text on signs/uniforms", "Merged or distorted small objects", "Subtle historical inaccuracies"]
  },
  {
    id: 6,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+6",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a cat playing a piano real or AI-generated?",
    source: "Generated by Midjourney",
    explanation: "This image is AI-generated. Animals playing instruments often look unnatural, and AI struggles with the fine details of paws and instrument keys. Look for unusual blurring or merging of elements.",
    pointers: ["Unnatural animal posture", "Distorted or missing details on instrument", "Odd lighting or shadows"]
  },
  {
    id: 7,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+7",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a famous landmark real or AI-generated?",
    source: "Travel Photography Magazine",
    explanation: "This is a real photograph. The architecture is perfectly symmetrical and detailed, and the surrounding environment is coherent and realistic. AI sometimes introduces subtle distortions in iconic structures.",
    pointers: ["Perfect architectural symmetry", "Clear and coherent background elements", "Realistic depth and perspective"]
  },
  {
    id: 8,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+8",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a futuristic car concept real or AI-generated?",
    source: "Generated by Stable Diffusion",
    explanation: "This image is AI-generated. While impressive, notice the subtle inconsistencies in the car's design, like non-functional door handles or strangely shaped windows. AI models can invent details that aren't practical.",
    pointers: ["Inconsistent vehicle design details", "Non-functional elements (e.g., door handles)", "Odd reflections or shadows on metallic surfaces"]
  },
  {
    id: 9,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+9",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a family dinner real or AI-generated?",
    source: "Personal Album",
    explanation: "This is a real photo. The faces are expressive and unique, and the interactions between individuals seem natural. AI often struggles with genuine emotional expressions and consistent facial features in group photos.",
    pointers: ["Genuine facial expressions", "Consistent features across individuals", "Natural interactions and body language"]
  },
  {
    id: 10,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+10",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a mythical creature real or AI-generated?",
    source: "Generated by Midjourney",
    explanation: "This image is AI-generated. AI is excellent at creating fantastical creatures, but often leaves subtle clues like unusual texture patterns, repeating scales, or a general 'dreamlike' blur that isn't typical of real photography.",
    pointers: ["Unnatural textures or patterns", "Repeating or symmetrical anomalies", "Overall 'painterly' or 'dreamlike' effect"]
  },
  {
    id: 11,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+11",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a chef cooking real or AI-generated?",
    source: "Food Blog",
    explanation: "This is a real photograph. The details in the food, the kitchen utensils, and the chef's hands are all sharp and realistic. AI sometimes struggles with intricate food details and human hands holding objects.",
    pointers: ["Sharp and realistic food details", "Natural interaction with utensils", "Detailed and natural looking hands"]
  },
  {
    id: 12,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+12",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a unique abstract painting real or AI-generated?",
    source: "Generated by DALL-E",
    explanation: "This painting is AI-generated. While compelling, AI can often create patterns or textures that are too perfect, or too chaotic, lacking the subtle imperfections and brushstroke variety of human art. Look for unnatural repeating motifs.",
    pointers: ["Overly uniform or repetitive patterns", "Lack of genuine brushstroke texture", "Unusual or illogical color transitions"]
  },
  {
    id: 13,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+13",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a vintage car real or AI-generated?",
    source: "Classic Car Show",
    explanation: "This is a real photo. The reflections on the car's surface are accurate to the environment, and the chrome details are crisp. AI often struggles with realistic reflections and metallic surfaces.",
    pointers: ["Accurate environmental reflections", "Crisp chrome and metallic details", "Realistic wear and tear if applicable"]
  },
  {
    id: 14,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+14",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a person with very unusual eyes real or AI-generated?",
    source: "Generated by StyleGAN",
    explanation: "This image is AI-generated. While the face might look convincing, AI often makes subtle mistakes around the eyes – mismatched pupils, unusual reflections, or strange irises. Hairline and ears can also be indicators.",
    pointers: ["Mismatched or distorted pupils/irises", "Unnatural reflections in eyes", "Strange hairline or ear shapes"]
  },
  {
    id: 15,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+15",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a pet real or AI-generated?",
    source: "Personal Pet Photo",
    explanation: "This is a real photograph. The fur texture is natural, and the animal's eyes have genuine sparkle and alignment. AI can sometimes make animals look too 'perfect' or have uncanny valley effects.",
    pointers: ["Natural fur/feather texture", "Genuine eye sparkle and alignment", "Realistic proportions and pose"]
  },
  {
    id: 16,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+16",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a strange new plant species real or AI-generated?",
    source: "Generated by Midjourney",
    explanation: "This image is AI-generated. While AI can create novel forms, look for unusual repeating patterns in leaves or petals, or a lack of natural biological irregularities that real plants possess. Background often appears less detailed.",
    pointers: ["Repetitive patterns in leaves/petals", "Lack of natural imperfections", "Inconsistent background details"]
  },
  {
    id: 17,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+17",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a bustling city cafe real or AI-generated?",
    source: "Local Cafe Photography",
    explanation: "This is a real photo. The small details like legible text on menus, consistent coffee foam, and unique faces in the background suggest authenticity. AI often struggles with realistic text and individualizing background elements.",
    pointers: ["Legible text on menus/signs", "Consistent and natural food/drink details", "Unique and varied background faces"]
  },
  {
    id: 18,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Image+Example+18",
    mediaType: "image",
    isAIGenerated: true,
    title: "Is this image of a surreal landscape with floating islands real or AI-generated?",
    source: "Generated by DALL-E",
    explanation: "This image is AI-generated. Surreal landscapes are a prime example of AI's creativity, but look for inconsistencies in lighting, shadows that don't match the light source, or textures that seem to repeat unnaturally across different elements.",
    pointers: ["Inconsistent lighting/shadows", "Unnatural texture repetition", "Objects that defy physics or context"]
  },
  {
    id: 19,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=Real+Photo+Example+19",
    mediaType: "image",
    isAIGenerated: false,
    title: "Is this photo of a child's drawing real or AI-generated?",
    source: "Child's Art Portfolio",
    explanation: "This is a real photo. The imperfections, varying line thickness, and natural crayon/marker marks are characteristic of a child's hand. AI often makes drawings look too clean or too complex in a structured way.",
    pointers: ["Natural imperfections in drawing", "Varying line thickness and texture", "Realistic paper texture/creases"]
  },
  {
    id: 20,
    mediaLink: "https://placehold.co/600x400/808080/FFFFFF?text=AI+Video+Example+20", // Placeholder for a video
    mediaType: "video",
    isAIGenerated: true,
    title: "Is this short clip of a person speaking real or AI-generated?",
    source: "Generated by Synthesia (simulated)",
    explanation: "This video is AI-generated. Pay attention to subtle 'tells' in deepfake videos: unnatural eye blinks, a slight desync between lip movements and audio (if audio were present), and an overall 'flat' or 'too perfect' facial animation compared to real human expressions.",
    pointers: ["Unnatural eye blinks or gaze", "Subtle lip-sync issues (if audio is present)", "Lack of micro-expressions or natural human movement", "Consistent but robotic facial movements"]
  }
];

export default quizData;